import { createContext, useContext, useState } from "react";
import useSWR from "swr";
import { fetchData } from "../../../lib/dashboard/data";
import { sendData } from "../../../lib/dashboard/actions";
import { useDomesticMarketSpreadPriceContext } from "./DomesticMarketSpreadPriceContext";

const DomesticMarketSpreadPriceProducerContext = createContext();

const DomesticMarketSpreadPriceProducerProvider = ({ children }) => {
  const { setIsFavoritesModal } = useDomesticMarketSpreadPriceContext();
  const [inputProducerValues1, setInputProducerValues1] = useState({
    company: null,
    group: null,
    commodity: null,
  });
  const [inputProducerValues2, setInputProducerValues2] = useState({
    company: null,
    group: null,
    commodity: null,
  });

  const [producerChartData, setProducerChartData] = useState({
    data: [],
    isLoading: false,
  });

  const companies1 = useSWR("/domestic/producer/company", fetchData, {
    // dedupingInterval: 60 * 60 * 1000,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  const groups1 = useSWR(
    inputProducerValues1.company
      ? `/domestic/producer/group/${inputProducerValues1.company.id}`
      : null,
    fetchData,
    {
      // dedupingInterval: 60 * 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );
  const commodities1 = useSWR(
    inputProducerValues1.group
      ? `/domestic/producer/commodity/${inputProducerValues1.company.id}/${inputProducerValues1.group.id}`
      : null,
    fetchData,
    {
      // dedupingInterval: 60 * 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );
  const companies2 = useSWR("/domestic/producer/company", fetchData, {
    // dedupingInterval: 60 * 60 * 1000,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  const groups2 = useSWR(
    inputProducerValues2.company
      ? `/domestic/producer/group/${inputProducerValues2.company.id}`
      : null,
    fetchData,
    {
      // dedupingInterval: 60 * 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );
  const commodities2 = useSWR(
    inputProducerValues2.group
      ? `/domestic/producer/commodity/${inputProducerValues2.company.id}/${inputProducerValues2.group.id}`
      : null,
    fetchData,
    {
      // dedupingInterval: 60 * 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const handleShowChart = async (body) => {
    setProducerChartData((prev) => ({ ...prev, isLoading: true }));
    const res = await sendData(body, "/domestic/producer/ratio-chart");
    if (res.status === 200)
      setProducerChartData({ isLoading: false, data: res.data });
    setProducerChartData((prev) => ({
      ...prev,
      isLoading: false,
    }));
  };

  const handleSelectedProducerFavorite = async (favorite) => {
    const {
      company1,
      company1_id,
      group1,
      group1_id,
      commodity1,
      commodity1_id,
      company2,
      company2_id,
      group2,
      group2_id,
      commodity2,
      commodity2_id,
    } = favorite;

    setInputProducerValues1({
      company: { id: company1_id, name: company1 },
      group: { id: group1_id, name: group1 },
      commodity: commodity1 && { id: commodity1_id, name: commodity1 },
    });

    setInputProducerValues2({
      company: { id: company2_id, name: company2 },
      group: { id: group2_id, name: group2 },
      commodity: commodity2 && { id: commodity2_id, name: commodity2 },
    });

    await handleShowChart({
      company1_id,
      group1_id,
      commodity1_id,
      company2_id,
      group2_id,
      commodity2_id,
    });

    setIsFavoritesModal(false);
  };

  return (
    <DomesticMarketSpreadPriceProducerContext.Provider
      value={{
        handleSelectedProducerFavorite,
        producerChartData: producerChartData.data,
        // isChartLoading: producerChartData.isLoading,
        isProducerChartLoading: producerChartData.isLoading,
        handleShowChart,
        inputProducerValues1,
        setInputProducerValues1,
        companies1,
        groups1,
        commodities1,
        companies2,
        groups2,
        commodities2,
        inputProducerValues2,
        setInputProducerValues2,
      }}
    >
      {children}
    </DomesticMarketSpreadPriceProducerContext.Provider>
  );
};

export default DomesticMarketSpreadPriceProducerProvider;

export const useDomesticMarketSpreadPriceProducerContext = () =>
  useContext(DomesticMarketSpreadPriceProducerContext);
